import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { MessageModule } from 'primeng/message';
import { MessageDto } from '../../../Dto/Shared/MessageDto';
import { PdsMessageService } from '../../../Services/pds-message.service';

/**
 * Komponenta pro zobrazování zpráv
 */
@Component({
	selector: 'app-messages',
	standalone: true,
	templateUrl: './messages.component.html',
  styleUrl: './messages.component.css',
  imports: [CommonModule, MessageModule]
})
export class MessagesComponent implements OnInit {
  
	/**
	 * Konstruktor
	 * @param pdsMessageService
	 */
	constructor(private pdsMessageService: PdsMessageService) {}

	/**
	 * Inicializace komponenty
	 */
	ngOnInit(): void {
		this.pdsMessageService.onAdd.subscribe(x => this.add(x));
		this.pdsMessageService.onClearAll.subscribe(x => this.clearAll());
		this.pdsMessageService.onClear.subscribe(x => this.clear(x));
	}

	/**
	 * Klíč zprávy
	 */
  @Input() key: string;

  /**
   * Možnost zavření komponenty message.
   */
  @Input() closable: boolean = true;

	/**
	 * Signál  pro přidání zpráv
	 * @param message {MessageDto | MessageDto[]} Zpráva nebo pole zpráv
	 */
	messages: WritableSignal<MessageDto[]> = signal<MessageDto[]>([]);

	private _messages: MessageDto[] = [];

  display: boolean = false;

	/**
	 * Přidání zpráv
	 * @param message {MessageDto | MessageDto[]} Zpráva nebo pole zpráv
	 */
  add(message: MessageDto | MessageDto[]): void {
    if (message instanceof Array) {
			let msg = message.filter(x => x.key == this.key);
      if (msg.length > 0) this._messages = this._messages.concat(msg);
		} else {
			if ((message.key == this.key)) this._messages.push(message);
    }
    this.display = this._messages.length > 0;
    this.messages.set(this._messages);
	}

	/**
	 * Vyčištění všech zpráv
	 */
	clearAll(): void {
		this.messages.set([]);
    this._messages = [];
    this.display = false;
	}

	/**
	 * vyčištění zpráv podle klíče
	 * @param key {string} Klíč zprávy
	 * @returns void
	 */
	clear(key: string): void {
		if (this.key == key) {
			this.messages.set([]);
      this._messages = [];
      this.display = false;
		}
  }

  /**
   * Ikony primeng pro jednotlivé hlášky
   * @param severity {string}
   * @returns
   */
  iconBySeverity(severity: string): string {
    switch (severity) {
      case 'error':
        return 'pi pi-times-circle';
      case 'warn':
        return 'pi pi-exclamation-triangle';
      case 'info':
        return 'pi pi-info-circle';
      case 'success':
        return 'pi pi-check';
      default:
        return ''
    }

  }
}
